<template>
	<table class="table" id="table_sms_report">
		<thead></thead>
		<tbody></tbody>
		<tfoot></tfoot>
	</table>
</template>

<script>
	import { Utilities } from "../../utilities";
	import { mapGetters } from 'vuex';

	export default {
		props: ['data'],

		watch:{
	    	data: function(d){
		    	if ($.fn.DataTable.isDataTable('#table_sms_report')){
				 	$('#table_sms_report').DataTable().destroy();
				 	$('#table_sms_report tfoot').html("");
				}

				if(this.$route.path.indexOf('bet-raw') != -1){
					this.buildTableBetRaw(d);
				}else{
					this.buildTableBet(d);
				}
	    	}
		},
		computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},
		methods: {
			buildTableBetRaw: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					let game = vm.gameInfo.games[r.game_id];
					let prop = vm.gameInfo.props[r.prop_id];
					let channel = vm.getChannel(r.channel_id);
					let remove = r.status == -1 ? "remove" : "";
					html += "<tr class='"+remove+"'>"+
								"<td>"+i+"</td>"+
								"<td>"+moment(r.created_at, "YYYY-MM-DD HH:mm:ss.u").format("YYYY-MM-DD HH:mm:ss")+"</td>"+
								"<td>"+prop + "<br/>" + channel + "<br/>" + game + "</td>"+
								"<td>"+r.number+"</td>"+
								"<td class='right'>"+r.point+"</td>"+
								"<td>"+r.rate+"</td>"+
								"<td>"+r.commission+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.margin)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
								"<td>"+r.ip+"</td>"+
							"</tr>";
				}
	        	$("#table_sms_report thead").html("<tr>"+
													"<th>STT</th>"+
													"<th>Thời gian cược</th>"+
													"<th class='no-sort'>Kèo</th>"+
													"<th>Số</th>"+
													"<th class='right'>Cược</th>"+
													"<th class='no-sort'>Chung</th>"+
													"<th class='no-sort'>Cò</th>"+
													"<th class='right no-sort'>Tiền cò</th>"+
													"<th class='right'>Tiền xác</th>"+
													"<th class='right'>Thực thu</th>"+
													"<th class='no-sort'>IP</th>"+
												"</tr>");
	        	$("#table_sms_report tbody").html(html);
	        	this.buildSummaryRawFooter(d);
				$("#table_sms_report").DataTable({
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
								            columnDefs: [{
										        "targets": 'no-sort',
										        "orderable": false,
										    }]
										});
			},
			buildSummaryRawFooter: function(d){
				let vm = this;
				let totalPoint = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.point; }, 0);
				let totalMargin = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.margin; }, 0);
				let totalTurnOver = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.turn_over; }, 0);
				let totalBetAmount = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_amount; }, 0);

				var html = "<tr>"+
								"<td></td>"+
								"<td>Tổng cộng (tất cả)</td>"+
								"<td></td>"+
								"<td></td>"+
								"<td class='right'>"+totalPoint+"</td>"+
								"<td></td>"+
								"<td></td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalMargin)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalTurnOver)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalBetAmount)+"</td>"+
								"<td></td>"+
							"</tr>";

	        	$("#table_sms_report tfoot").html(html);
			},
			buildTableBet: function(d){
	        	let vm = this;
				var html = "";
				for(let i in d){
					var r = d[i];
					let game = vm.gameInfo.games[r.game_id];
					let prop = vm.gameInfo.props[r.prop_id];
					let channel = vm.getChannel(r.channel_id);
					let remove = r.status == -1 ? "remove" : "";
					html += "<tr bid='"+r.id+"' class='"+remove+"'>"+
								"<td>"+i+"</td>"+
								"<td>"+moment(r.created_at, "YYYY-MM-DD HH:mm:ss.u").format("YYYY-MM-DD HH:mm:ss")+"</td>"+
								"<td>"+prop + "<br/>" + channel + "<br/>" + game + "</td>"+
								"<td>"+r.number+"</td>"+
								"<td class='right'>"+r.point+"</td>"+
								"<td>"+r.rate+"</td>"+
								"<td>"+r.commission+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.margin)+"</td>"+
								"<td>"+r.duplicate+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.turn_over)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.bet_amount)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(r.net_amount)+"</td>"+
								"<td class='right'>"+vm.reportColor(r.winloss)+"</td>"+
								"<td>"+r.ip+"</td>"+
							"</tr>";
				}
	        	$("#table_sms_report thead").html("<tr>"+
													"<th>STT</th>"+
													"<th>Thời gian cược</th>"+
													"<th class='no-sort'>Kèo</th>"+
													"<th>Số</th>"+
													"<th class='right'>Cược</th>"+
													"<th class='no-sort'>Chung</th>"+
													"<th class='no-sort'>Cò</th>"+
													"<th class='right no-sort'>Tiền cò</th>"+
													"<th class='no-sort'>Ki</th>"+
													"<th class='right no-sort'>Tiền xác</th>"+
													"<th class='right no-sort'>Thực thu</th>"+
													"<th class='right no-sort'>Chênh lệch</th>"+
													"<th class='right'>Thắng thua</th>"+
													"<th class='no-sort'>IP</th>"+
												"</tr>");
	        	$("#table_sms_report tbody").html(html);
	        	this.buildSummaryFooter(d);
				$("#table_sms_report").DataTable({
											responsive: false,
						            		pagingType: "full_numbers",
								            searching: false,
								            dom: "<'row'<'col-sm-12'tr>>\n\t\t\t<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
								            columnDefs: [{
										        "targets": 'no-sort',
										        "orderable": false,
										    }]
										});
			},
			buildSummaryFooter: function(d){
				let vm = this;
				let totalPoint = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.point; }, 0);
				let totalMargin = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.margin; }, 0);
				let totalTurnOver = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.turn_over; }, 0);
				let totalBetAmount = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.bet_amount; }, 0);
				let totalNetAmount = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.net_amount; }, 0);
				let totalWinloss = d.reduce((total, currentValue) => { return currentValue.status == -1 ? total : total+currentValue.winloss; }, 0);

				var html = "<tr>"+
								"<td></td>"+
								"<td>Tổng cộng (tất cả)</td>"+
								"<td></td>"+
								"<td></td>"+
								"<td class='right'>"+Utilities.formatNumber(totalPoint)+"</td>"+
								"<td></td>"+
								"<td></td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalMargin)+"</td>"+
								"<td></td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalTurnOver)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalBetAmount)+"</td>"+
								"<td class='right'>"+Utilities.currencyFormat(totalNetAmount)+"</td>"+
								"<td class='right'>"+vm.reportColor(totalWinloss)+"</td>"+
								"<td></td>"+
							"</tr>";

	        	$("#table_sms_report tfoot").html(html);
			},

			getChannel: function(cid){
				if(!cid) return "";
				if(cid == "0") return "36";

				let vm = this;
				let cids = cid.split(".");
				let channels = cids.map((e) => { return vm.gameInfo.channels[e].alias; });

				return channels.join(", ");
			},

			reportColor: function(value){
				let color = value >= 0 ? 'blue' : 'red';
    			return "<span style='color:"+color+";'>" + Utilities.currencyFormat(value) + "</span>";
			}
		}
	}
</script>
<style>
	.right { text-align: right; }
</style>